import {Component, inject, signal} from "@angular/core";
import {environment} from "src/app/environments/environment";
import {NetworkStatusStore} from "src/app/infrastructure/network/network-status.store";
import {FarmApiClient} from "src/app/infrastructure/moovement-api/web-api/farm.api-client";

@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  imports: [],
  styleUrl: './offline.component.css'
})
export class OfflineComponent {
  private readonly farmApiClient = inject(FarmApiClient);

  checkingConnection = signal(false);

  readonly store = inject(NetworkStatusStore);
  readonly notification = environment.platform == 'web' ?
    'You are offline. The portal cannot work without an active internet connection.' :
    'You are currently offline. Some features are not available.';

  refresh(): void {
    // The network status plugin is not always reliable.
    // This HTTP request does provide a reliable way to check
    // the connection.
    this.checkingConnection.set(true);
    this.farmApiClient.getFarmReferences().subscribe({
      next: () => {
        this.store.setOnline();
        this.checkingConnection.set(false);
      }, error: () => {
        this.store.setOffline();
        this.checkingConnection.set(false);
      }
    });
  }
}
